import {EInputTextType, Input} from '../../../components/Input/Input';
import {OfferProduct, ProductStatus} from '../../../types/offerProduct.type';
import React, {useEffect, useState} from 'react';
import './calculateOfferModal.scss';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router';
import {RootState} from '../../../reducers';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import * as actions from '../../../actions/generalActions';
import * as offerActions from '../../../actions/offers';
import * as adminActions from '../../../actions/admin';
import DifferentColoredPlus from '../../../assets/icons/differentColoredPlus.svg';
import MikaSelect from '../../../components/BbrosSelect/mikaSelect.component';
import MultiSelectFilter from '../../../components/MultiSelectFilter/MultiSelectFilter';
import {ArticleInfomation} from '../../../types/ArticleInformation.type';
import {axiosCaller} from '../../../utils/apiCaller';
import {SelectOption} from '../../../types/selectOption.type';
import {Button} from '../../../components/Button'
import {toast} from "react-toastify";
import {formatNumberPrice, toFixedNumber} from '../../../utils/react';
import {formatDate} from '../../../utils/variableEvaluation';
import clearFormSvg from "../../../assets/icons/archeology.svg";
import Tooltip from "rc-tooltip";
import DeleteModalComponent from "../../../components/Modal/DeleteModal";
import ModalComponent from "../../../components/Modal/ModalComponent";
import FontAwesome from 'react-fontawesome';
import styles from "../../../components/Input/AssigneeBoxInput/AssigneeBoxInput.module.scss";
import {checkCorrespondingInput, setOnlyNewCorrespondingItems} from "../../Admin/globalFunctions";
import moment from "moment";
import SubProductSection from './SubProductSection';
import OfferBomSection from './OfferBomSection';
import DiscountedPrice from './DiscountedPrice';
import {OfferSubProduct} from '../../../types/offerProduct.type';

interface Props {
    data?: OfferProduct;
    offers: any;
    offerActions: any;
    indexWhereThisProductIsPlacedInTheArray: number,
    products: OfferProduct[];
    setProducts?: (value: OfferProduct[] | ((prevVar: OfferProduct[]) => OfferProduct[])) => void;
    articles: ArticleInfomation[];
    intl: any;
    adminActions: any;
    admin: any;
    client: any;
    getProductsOfClient?: () => void,
    setUpdateDatesPayload?: (any) => void
    discount?: number,
    history?: any,
    permissions: any,
    offerId: any
    projectDetails: any
    companyProfile?: any
}

const Product = (props: Props) => {
    const fm = (id: string, defaultMessage: string, values?: Record<string, any>) =>
        props.intl.formatMessage({ id, defaultMessage }, values);

    const [product, setProduct] = useState<any>({} as any);
    const [calculatedTotalProductPrice, setCalculatedTotalProductPrice] = useState<number>(0);
    const [productTaxPrice, setProductTaxPrice] = useState<number>(0);
    const [selectedUnitName, setSelectedUnitName] = useState<number>();
    const [selectedWarehouseQuantity, setSelectedWarehouseQuantity] = useState<number>();
    const [selectedUnitId, setSelectedUnitId] = useState<number>();
    const [productCode, setProductCode] = useState<string>();
    const [articleId, setArticleId] = useState<number>();
    const [forProduction, setForProduction] = useState<boolean>(true)
    const [forProductionInnerStock, setForProductionInnerStock] = useState<boolean>(true)
    // KuBIT item type of the line's article (4 = manufactured). Drives the KuBIT
    // per-offer BOM section. Captured from the same articles/{id}/responsibilities
    // fetch the row already makes; null for non-KuBIT / unknown.
    const [kubitItemTypeId, setKubitItemTypeId] = useState<number | null>(null)
    const [buttonLoader, setButtonLoader] = useState<boolean>(false)
    const [isDeleteModalOpen, setDeleteModal] = useState<boolean>(false);
    const [isCancelModalOpen, setCancelModal] = useState<boolean>(false);
    const [selectedProductIndex, setSelectedProductIndex] = useState<number>(null);

    // Sherbim (material-based product) states
    const [isSherbim, setIsSherbim] = useState<boolean>(false);
    const [materials, setMaterials] = useState<SelectOption[]>([]);
    const [allResponsibilities, setAllResponsibilities] = useState<SelectOption[]>([]);
    const [selectedResponsibilities, setSelectedResponsibilities] = useState<SelectOption[]>([]);
    const [responsibilityOrders, setResponsibilityOrders] = useState<{[key: number]: number}>({});
    const [selectedMaterial, setSelectedMaterial] = useState<SelectOption | null>(null);
    const [isEditingResponsibilities, setIsEditingResponsibilities] = useState<boolean>(false);
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const [subProductsTotal, setSubProductsTotal] = useState<number>(0);
    const [subProductsDiscountedTotal, setSubProductsDiscountedTotal] = useState<number>(0);

    useEffect(() => {
        console.log('========== Product Component RENDERED ==========');
        console.log('props.data:', props.data);
        console.log('Product ID:', props.data?.id);
        console.log('Product materialId:', props.data?.materialId);
        console.log('Product designation:', props.data?.designation);
        console.log('props.projectDetails:', props.projectDetails);
        console.log('shipmentDestinationId:', props.projectDetails?.shipmentDestinationId);
    }, [props.data, props.projectDetails]);

    useEffect(() => {
        // Convert date strings to Date objects for date picker
        const productData = props.data ? {
            ...props.data,
            start: props.data.start ? new Date(props.data.start) : null,
            end: props.data.end ? new Date(props.data.end) : null,
        } : {};

        setProduct(productData);

        // Material-based products (Sherbim) are disabled - only article-based products are supported
        // Keeping this code for reference but it will never execute
        if (false) {
            setIsSherbim(true);
        }
    }, [props.projectDetails]);

    // Fetch materials and responsibilities for Sherbim projects
    useEffect(() => {
        if (isSherbim) {
            // Clear previous state first to avoid mixing
            setMaterials([]);
            setAllResponsibilities([]);
            setSelectedMaterial(null);
            setSelectedResponsibilities([]);
            setResponsibilityOrders({});

            // Fetch all materials
            axiosCaller('GET', 'admin/material').then((res) => {
                // MaterialWithResponsibilitiesResource already returns {value, label}
                const materialOptions = res.data?.data || res.data || [];
                setMaterials(materialOptions);
            }).catch(() => {
                toast.error(fm('offer.product.toast.materialsLoadFailed', 'Could not load materials'));
            });

            // Fetch all responsibilities
            axiosCaller('GET', 'responsibilities').then((res) => {
                // ResponsibilityResource returns {id, label}, map id to value
                const respOptions = res.data?.data?.map((resp: any) => ({
                    label: resp.label || resp.name,
                    value: resp.id || resp.value
                })) || [];
                setAllResponsibilities(respOptions);
            }).catch(() => {
                toast.error(fm('offer.product.toast.responsibilitiesLoadFailed', 'Could not load processes'));
            });
        }
    }, [isSherbim, props.data?.id]);

    // Load saved material and responsibilities data when editing existing product
    useEffect(() => {
        if (isSherbim && props.data?.materialId && materials.length > 0 && allResponsibilities.length > 0) {
            console.log('Loading saved product data into state:', props.data.id);

            // Set selected material
            const material = materials.find(m => m.value === props.data.materialId);
            if (material) {
                setSelectedMaterial(material);
            }

            // Set selected responsibilities
            if (props.data.responsibilities && props.data.responsibilities.length > 0) {
                const selectedResp = props.data.responsibilities.map((resp: any) => ({
                    label: resp.label,
                    value: resp.id
                }));
                setSelectedResponsibilities(selectedResp);

                // Set responsibility orders
                const orders: {[key: number]: number} = {};
                props.data.responsibilities.forEach((resp: any) => {
                    orders[resp.id] = resp.order;
                });
                setResponsibilityOrders(orders);

                console.log('Updated selectedResponsibilities with fresh data:', selectedResp);
            }

            // Reset editing flag AFTER updating state with fresh data
            // This ensures the UI shows the correct count from fresh data
            setIsEditingResponsibilities(false);
        }
    }, [isSherbim, props.data?.id, props.data?.materialId, props.data?.responsibilities, materials, allResponsibilities]);

    useEffect(() => {
        if (props?.data?.type) {
            setProductCode(props?.data?.type);
        }
        if (!isSherbim && product?.designation?.value) {
            axiosCaller('GET', `articles/${product?.designation?.value}/responsibilities`).then((res) => {
                setSelectedUnitName(res.data?.data?.unit?.name);
                setSelectedUnitId(res.data?.data?.unit?.id);
                setSelectedWarehouseQuantity(res.data?.data?.warehouse?.quantity)
                setKubitItemTypeId(res.data?.data?.kubitItemTypeId ?? null);
                if (!product?.type) {
                    setProductCode(res.data?.data?.productCode);
                }
            });
        }
    }, [product?.designation, isSherbim])

    const handleChange = (name, value) => {
        // Date validation for Sherbim products
        if (isSherbim && name === 'start') {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const selectedDate = new Date(value);
            selectedDate.setHours(0, 0, 0, 0);

            if (selectedDate < today) {
                toast.error(fm('offer.product.toast.startDateInPast', 'The start date cannot be in the past!'));
                return;
            }
        }

        if (isSherbim && name === 'end') {
            if (product?.start) {
                const startDate = new Date(product.start);
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(value);
                endDate.setHours(0, 0, 0, 0);

                if (endDate < startDate) {
                    toast.error(fm('offer.product.toast.endBeforeStart', 'The end date cannot be before the start date!'));
                    return;
                }
            }
        }

        setProduct({
            ...product,
            totalPrice: calculatedTotalProductPrice,
            taxPrice: productTaxPrice,
            [name]: value,
        });
    };

    const removeProduct = (index: number) => {
        setSelectedProductIndex(index)
        setDeleteModal(true)
    };

    const selectProductForCancellation = (index: number) => {
        setSelectedProductIndex(index)
        setCancelModal(true)
    };

    const deleteProduct = () => {
        let productsCopy = [...props.products];
        productsCopy.splice(selectedProductIndex, 1);
        props.setProducts(productsCopy);
        if (product?.id) {
            axiosCaller('DELETE', `products/${product.id}`).then((res) => {
                if (res?.data?.finishedProduct) {
                    toast.info(fm('offer.product.toast.inArchive', 'The product is in the archive and cannot be deleted!'))
                    return
                }
                if (res.data.data === true) {
                    toast.success(fm('offer.product.toast.deleted', 'Product deleted successfully!'))
                    setDeleteModal(false)
                    props.getProductsOfClient()
                }
            });
        }
    };

    const cancelProduct = () => {
        console.log(product, 'product')

        let payload = {
            canceled: 1,
            offerId: product?.offerId,
            clientId: product?.clientID,
            type: product?.type,
            designation: product?.designation?.value,
            quantity: product?.unit,
            price: product?.price,
            discount: product?.discount,
            tax: product?.tax,
            start: product?.start,
            end: product?.end
        }
        if (product?.id) {
            axiosCaller('POST', `products/${product.id}`, payload).then((res) => {
                if (res.data.data.id) {
                    toast.success(fm('offer.product.toast.canceled', 'Product canceled successfully!'))
                    setDeleteModal(false)
                    props.getProductsOfClient()
                    props.offerActions.fetchClientOffer(props.offerId)
                }
            });
        }
    };

    useEffect(() => {
        let allProductsCopy = [...props.products];
        let discountedPrice = Number(product.price) - (Number(product.price) * (Number(product.discount) / 100));
        let taxPrice = discountedPrice + (discountedPrice * (product.tax / 100));
        let totalProductPrice = Number(taxPrice) * Number(product.unit);
        setProductTaxPrice(taxPrice);
        setCalculatedTotalProductPrice(totalProductPrice);

        allProductsCopy[props.indexWhereThisProductIsPlacedInTheArray] = {
            ...product,
            totalPrice: totalProductPrice
        };
        props.setProducts(allProductsCopy);
    }, [product]);

    /**
     * Check if responsibilities can be edited for Sherbim projects
     * For Sherbim projects: editable only if ALL productStatuses have responsibility_status_id = 2
     * For non-Sherbim projects: use original logic (disabled when product exists)
     */
    const canEditResponsibilities = () => {
        // For Sherbim projects only
        if (isSherbim) {
            console.log('=== canEditResponsibilities CHECK ===');
            console.log('Product ID:', product.id);
            console.log('props.data:', props.data);
            console.log('props.data?.productStatuses:', props.data?.productStatuses);

            // New products are always editable
            if (!product.id) {
                console.log('New product - EDITABLE');
                return true;
            }

            // Check if product has productStatuses data
            if (!props.data?.productStatuses || props.data.productStatuses.length === 0) {
                // If no statuses exist yet, allow editing
                console.log('No productStatuses found - EDITABLE');
                return true;
            }

            // Check if ALL productStatuses have responsibility_status_id = 2
            console.log('Checking all productStatuses:');
            props.data.productStatuses.forEach((ps: any, idx: number) => {
                console.log(`  Status ${idx}: responsibility_status_id =`, ps.responsibility_status_id);
            });

            const allAreWaitingForProduction = props.data.productStatuses.every((ps: any) => {
                return ps.responsibility_status_id === 2;
            });

            console.log('All have status ID 2?', allAreWaitingForProduction);
            console.log('Result: ' + (allAreWaitingForProduction ? 'EDITABLE' : 'NOT EDITABLE'));

            return allAreWaitingForProduction;
        }

        // For non-Sherbim projects: use original logic
        // Existing products are disabled
        return !product.id;
    };

    function saveArticleAndUnit(name: string, value: SelectOption) {
        axiosCaller('GET', `articles/${value?.value}/responsibilities`).then((res) => {
            setSelectedUnitName(res.data?.data?.unit?.name);
            setSelectedUnitId(res.data?.data?.unit?.id);
            setArticleId(value?.value)
            setForProduction(res.data?.data?.forProduction)
            setKubitItemTypeId(res.data?.data?.kubitItemTypeId ?? null);
            const pricePerUnit = res.data?.data?.pricePerUnit;
            setProduct((prev) => ({
                ...prev,
                totalPrice: calculatedTotalProductPrice,
                taxPrice: productTaxPrice,
                [name]: value,
                ...(pricePerUnit != null ? { price: pricePerUnit } : {})
            }));
        });
    }

    function saveProduct() {
        let tempProductIdArray = []
        props?.products?.forEach((propsProduct) => {
            if (propsProduct?.id) {
                tempProductIdArray?.push(propsProduct?.id)
            }
        })
        if (!(product?.designation?.value && product?.unit)) {
            toast.info(fm('offer.product.toast.fillData', 'Please fill in the data!'))
            return
        }
        axiosCaller('POST', `products/agreements/start-end-date`, {
            quantity: product.unit,
            unitId: selectedUnitId,
            articleId: product.designation.value,
            productIds: tempProductIdArray
        }).then(res => {
            setProduct({
                ...product,
                end: product?.id ? product?.end : res.data.data?.end,
                start: product?.id ?  product?.start  : res.data.data?.start
            });
            let payload = {
                type: productCode,
                designation: product?.designation?.value,
                quantity: product?.unit,
                price: product?.price,
                tax: product?.tax,
                taxPrice: productTaxPrice,
                end: product?.id ? product?.end : res.data.data?.end,
                start: product?.id ?  product?.start  : res.data.data?.start,
                discount: product?.discount,
                clientId: props?.client?.client?.id,
                offerId: null,
                forProduction: forProductionInnerStock ? 1 : 0,
                note: product?.note ?? null
            }
            if (props.offers?.offerClient?.id || props.offers?.offerClient?.id !== "undefined") {
                payload.offerId = props.offers?.offerClient?.id
            }
            if (product.id) {
                axiosCaller('POST', `products/${product.id}`, payload).then(() => {
                    toast.success(fm('offer.product.toast.edited', 'Product updated successfully'))
                    setButtonLoader(false)
                }).catch(() => {
                    toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'))
                })
            } else {
                axiosCaller('POST', `products`, payload).then((res) => {
                    if (res?.data?.data) {
                        setProduct(res?.data?.data)
                        props.setProducts([
                            ...props.products,
                            res?.data?.data
                        ])
                        toast.success(fm('offer.product.toast.saved', 'Product saved successfully'))
                        setButtonLoader(false)
                    }
                }).catch(() => {
                    toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'))
                })
            }
        });
        setButtonLoader(true)
    }

    function manuallyUpdateStartAndEndDates() {
        props.setUpdateDatesPayload(
            {
                startDate: product?.start,
                endDate: product?.end,
                articleId: product.designation?.value,
                productId: product?.id,
                quantity: product?.unit
            }
        )
    }

    const handleResponsibilityChange = (values: SelectOption[]) => {
        console.log('handleResponsibilityChange called with:', values);
        setIsEditingResponsibilities(true); // Mark that user is editing
        setSelectedResponsibilities(values);

        // Build new orders object, only keeping currently selected responsibilities
        const newOrders: {[key: number]: number} = {};
        const currentOrderValues = Object.values(responsibilityOrders);
        const maxOrder = currentOrderValues.length > 0 ? Math.max(...currentOrderValues) : 0;
        let nextOrder = maxOrder + 1;

        values.forEach((resp) => {
            const respId = resp.value as number;
            // If this responsibility already had an order, keep it
            if (responsibilityOrders[respId]) {
                newOrders[respId] = responsibilityOrders[respId];
            } else {
                // Otherwise, assign the next available order
                newOrders[respId] = nextOrder;
                nextOrder++;
            }
        });

        setResponsibilityOrders(newOrders);
    };

    const handleResponsibilityOrderChange = (responsibilityId: number, order: number) => {
        console.log('handleResponsibilityOrderChange called:', { responsibilityId, order });
        setIsEditingResponsibilities(true); // Mark that user is editing
        setResponsibilityOrders({
            ...responsibilityOrders,
            [responsibilityId]: order
        });
    };

    // Save function for material-based products (Sherbim)
    function saveMaterialProduct() {
        // Validation
        if (!selectedMaterial?.value) {
            toast.info(fm('offer.product.toast.selectMaterial', 'Please select a material!'));
            return;
        }
        if (!product?.unit || isNaN(product?.unit)) {
            toast.info(fm('offer.product.toast.enterQuantity', 'Please enter the quantity (numbers only)!'));
            return;
        }
        if (selectedResponsibilities.length === 0) {
            toast.info(fm('offer.product.toast.selectProcess', 'Please select at least one production process!'));
            return;
        }
        if (!product?.start || !product?.end) {
            toast.info(fm('offer.product.toast.enterDates', 'Please enter the start and end dates!'));
            return;
        }

        setButtonLoader(true);

        // Format responsibilities with their order
        const formattedResponsibilities = selectedResponsibilities.map(resp => ({
            id: resp.value,
            order: responsibilityOrders[resp.value as number] || 1
        }));

        const payload = {
            materialId: selectedMaterial.value,
            quantity: product.unit,
            unit: selectedUnitName || product.unitText,
            price: product.price,
            tax: product.tax,
            discount: product.discount,
            start: product.start,
            end: product.end,
            clientId: props.client?.client?.id,
            offerId: props.offers?.offerClient?.id || null,
            forProduction: 1,
            responsibilities: formattedResponsibilities,
            // Flag to tell backend to recreate product_status records
            recreateStatuses: product.id ? 1 : 0,
            note: product?.note ?? null
        };

        if (product.id) {
            // Update existing material product
            // Backend should delete all existing product_status records and create new ones
            axiosCaller('POST', `products/${product.id}`, payload).then(() => {
                toast.success(fm('offer.product.toast.edited', 'Product updated successfully'));
                setButtonLoader(false);
                // Don't reset isEditingResponsibilities here - wait for fresh data to arrive
                // Refresh products to get updated productStatuses
                if (props.getProductsOfClient) {
                    props.getProductsOfClient();
                }
            }).catch(() => {
                toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'));
                setButtonLoader(false);
            });
        } else {
            // Create new material product
            axiosCaller('POST', 'products', payload).then((res) => {
                if (res?.data?.data) {
                    // Convert date strings to Date objects
                    const productData = {
                        ...res.data.data,
                        start: res.data.data.start ? new Date(res.data.data.start) : null,
                        end: res.data.data.end ? new Date(res.data.data.end) : null,
                    };
                    setProduct(productData);
                    props.setProducts([...props.products, productData]);
                    toast.success(fm('offer.product.toast.saved', 'Product saved successfully'));
                    setButtonLoader(false);
                    // Don't reset isEditingResponsibilities here - wait for fresh data
                }
            }).catch(() => {
                toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'));
                setButtonLoader(false);
            });
        }
    }

    useEffect(() => {
        if(selectedWarehouseQuantity && product.unit && product.unit > selectedWarehouseQuantity){
            setForProductionInnerStock(true)
        }
    }, [product.unit]);

    return (
        <div className="product-card">

            {/* ── Card header: title + all actions ── */}
            <div className="product-card-header">
                <p className="product-card-title" onClick={() => setCollapsed(c => !c)}>
                    <FontAwesome name="chevron-down" className={`product-collapse-chevron ${collapsed ? 'is-collapsed' : ''}`}/>
                    {product.designation?.label
                        ? product.designation.label
                        : <FormattedMessage id="offer.product.newProduct" defaultMessage="New product"/>
                    }
                </p>
                <div className="product-card-actions">
                    {!!product?.canceled && (
                        <div className="canceledLabel">
                            <p><FormattedMessage id="offer.product.isCanceled" defaultMessage="This product is canceled!"/></p>
                        </div>
                    )}
                    {!!selectedWarehouseQuantity && !forProduction && (
                        <div className="forProductionInnerStockCheck">
                            <Tooltip placement="top" overlay={<span>{fm('offer.product.forProduction', 'For production')}</span>}>
                                <div className="round-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={forProductionInnerStock}
                                        onChange={(e) => setForProductionInnerStock(e?.target?.checked)}
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    )}
                    {((!props.permissions.observer) || props.permissions.fullPrivileges) && (
                        <>
                            <Button
                                isLoading={buttonLoader}
                                isDisabled={buttonLoader}
                                onClick={isSherbim ? saveMaterialProduct : saveProduct}
                                className="product-save-btn calculateOfferButton align-items-center text-center">
                                <Tooltip placement="top" overlay={<span>{fm('offer.product.saveTooltip', 'Save product')}</span>}>
                                    <FontAwesome name={'save'}/>
                                </Tooltip>
                            </Button>
                            {!!product?.id && (
                                <Button
                                    isLoading={buttonLoader}
                                    isDisabled={buttonLoader}
                                    onClick={manuallyUpdateStartAndEndDates}
                                    className="product-dates-btn calculateOfferButton align-items-center text-center">
                                    <FormattedMessage id="offer.product.changeDates" defaultMessage="Change dates"/>
                                </Button>
                            )}
                        </>
                    )}
                    {!product?.canceled && (
                        <div className="cancel-sign" onClick={() => selectProductForCancellation(props.indexWhereThisProductIsPlacedInTheArray)}>
                            <Tooltip placement="top" overlay={<span>{fm('offer.product.cancelTooltip', 'Cancel product')}</span>}>
                                <img src={DifferentColoredPlus} alt={fm('offer.product.cancelAlt', 'Cancel')}/>
                            </Tooltip>
                        </div>
                    )}
                    <div className="x-sign" onClick={() => removeProduct(props.indexWhereThisProductIsPlacedInTheArray)}>
                        <Tooltip placement="top" overlay={<span>{fm('offer.product.deleteTooltip', 'Delete product')}</span>}>
                            <FontAwesome name={'trash'}/>
                        </Tooltip>
                    </div>
                </div>
            </div>

            {/* ── Card body: single row of inputs ── */}
            {!collapsed && <div className="product-card-body">

                <div className="pf-table">
                    <div className="pf-header">
                        <div><FormattedMessage id="offer.product.col.article" defaultMessage="Article" /></div>
                        <div><FormattedMessage id="offer.product.col.code" defaultMessage="Code" /></div>
                        <div><FormattedMessage id="offer.product.col.unit" defaultMessage="Unit" /></div>
                        <div><FormattedMessage id="offer.product.col.quantity" defaultMessage="Quantity" /></div>
                        <div><FormattedMessage id="offer.product.col.price" defaultMessage="Price" /></div>
                        <div><FormattedMessage id="offer.product.col.discountPct" defaultMessage="Disc. %" /></div>
                        <div><FormattedMessage id="offer.product.col.taxPct" defaultMessage="VAT %" /></div>
                        <div><FormattedMessage id="offer.product.col.total" defaultMessage="Total" /></div>
                        <div><FormattedMessage id="offer.product.col.start" defaultMessage="Start" /></div>
                        <div><FormattedMessage id="offer.product.col.end" defaultMessage="End" /></div>
                    </div>
                    <div className="pf-row">
                        {!isSherbim ? (
                            <>
                                <div className="pf-cell pf-article" data-label={fm('offer.product.col.article', 'Article')} title={product.designation?.label || ''}>
                                    <MikaSelect
                                        selectWrapperClassName="designation-select"
                                        value={product.designation}
                                        placeholder={fm('offer.product.chooseArticle', 'Articles')}
                                        name="designation"
                                        setValueFunction={(name, value) => saveArticleAndUnit(name, value)}
                                        options={props.articles}
                                        disabled={product.id && true}
                                        isOfferModalProduct
                                    />
                                </div>
                                <div className="pf-cell" data-label={fm('offer.product.col.code', 'Code')}>
                                    <input
                                        type="text"
                                        value={productCode || ''}
                                        onChange={(e) => setProductCode(e.target.value)}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="pf-cell pf-article" data-label={fm('offer.product.col.article', 'Article')}>
                                    <MikaSelect
                                        selectWrapperClassName="designation-select"
                                        value={isEditingResponsibilities ? selectedMaterial : (props.data?.id ? props.data.designation : selectedMaterial)}
                                        placeholder={fm('offer.product.selectMaterial', 'Select material')}
                                        name="material"
                                        setValueFunction={(name, value) => {
                                            setIsEditingResponsibilities(true);
                                            setSelectedMaterial(value);
                                        }}
                                        options={materials}
                                        disabled={!canEditResponsibilities()}
                                        isOfferModalProduct
                                    />
                                </div>
                                <div className="pf-cell" data-label={fm('offer.product.col.code', 'Code')}>
                                    {(() => {
                                        const isEditable = canEditResponsibilities();
                                        const displayedValues = isEditingResponsibilities
                                            ? selectedResponsibilities
                                            : (props.data?.id && props.data?.responsibilities
                                                ? props.data.responsibilities.map((resp: any) => ({label: resp.label, value: resp.id}))
                                                : selectedResponsibilities);
                                        const displayedOrders = isEditingResponsibilities
                                            ? responsibilityOrders
                                            : (props.data?.id && props.data?.responsibilities
                                                ? props.data.responsibilities.reduce((acc: any, resp: any) => ({...acc, [resp.id]: resp.order}), {})
                                                : responsibilityOrders);
                                        return (
                                            <MultiSelectFilter
                                                label=""
                                                options={allResponsibilities}
                                                selectedValues={displayedValues}
                                                onChange={handleResponsibilityChange}
                                                placeholder={fm('offer.product.processesPlaceholder', 'Processes...')}
                                                disabled={!isEditable}
                                                showCountInstead={true}
                                                orderInputs={displayedOrders}
                                                onOrderChange={handleResponsibilityOrderChange}
                                            />
                                        );
                                    })()}
                                </div>
                            </>
                        )}
                        <div className="pf-cell" data-label={fm('offer.product.col.unit', 'Unit')}>
                            <input
                                type="text"
                                value={isSherbim ? (product.unitText || '') : (selectedUnitName || '')}
                                disabled={!isSherbim}
                                onChange={isSherbim ? (e) => handleChange('unitText', e.target.value) : undefined}
                            />
                        </div>
                        <div className="pf-cell" data-label={fm('offer.product.col.quantity', 'Quantity')}>
                            <input
                                type="text"
                                inputMode="decimal"
                                value={product.unit || ''}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val !== '' && !/^\d*\.?\d*$/.test(val)) return;
                                    handleChange('unit', val);
                                }}
                            />
                            {selectedWarehouseQuantity &&
                                <span className="pf-stock-badge" title={fm('offer.product.stockTooltip', 'Warehouse quantity')}>{fm('offer.product.stockLabel', 'Stock')}: {selectedWarehouseQuantity}</span>}
                        </div>
                        <div className="pf-cell" data-label={fm('offer.product.col.price', 'Price')}>
                            <input
                                type="text"
                                inputMode="decimal"
                                value={formatNumberPrice(String(product.price), 2) || ''}
                                onChange={(e) => { const v = e.target.value; if (v !== '' && !/^\d*\.?\d*$/.test(v)) return; handleChange('price', v); }}
                            />
                        </div>
                        <div className="pf-cell" data-label={fm('offer.product.col.discountPct', 'Disc. %')}>
                            <input
                                type="text"
                                inputMode="decimal"
                                value={formatNumberPrice(String(product.discount), 2) || ''}
                                onChange={(e) => { const v = e.target.value; if (v !== '' && !/^\d*\.?\d*$/.test(v)) return; handleChange('discount', v); }}
                            />
                        </div>
                        <div className="pf-cell" data-label={fm('offer.product.col.taxPct', 'VAT %')}>
                            <input
                                type="text"
                                inputMode="decimal"
                                value={formatNumberPrice(String(product.tax), 2) || ''}
                                onChange={(e) => { const v = e.target.value; if (v !== '' && !/^\d*\.?\d*$/.test(v)) return; handleChange('tax', v); }}
                            />
                        </div>
                        <div className="pf-cell pf-total-cell" data-label={fm('offer.product.col.total', 'Total')}>
                            {props?.discount && (!product?.canceled) ? (
                                <DiscountedPrice original={+calculatedTotalProductPrice} discounted={+props.discount} />
                            ) : (
                                <input
                                    type="text"
                                    disabled
                                    value={toFixedNumber(calculatedTotalProductPrice, 2) || ''}
                                />
                            )}
                        </div>
                        <div className="pf-cell pf-date-cell" data-label={fm('offer.product.col.start', 'Start')}>
                            <input
                                type={isSherbim ? "date" : "text"}
                                value={(product?.start && (isSherbim ? product?.start : formatDate(product?.start))) || ''}
                                onChange={isSherbim ? (e) => handleChange('start', e.target.value) : undefined}
                                disabled={!isSherbim}
                            />
                            {product?.initialStart && (
                                <Tooltip placement="top" overlay={<span>{fm('offer.product.initialDate', 'Initial date')}: {moment(product?.initialStart)?.format("DD-MM-YYYY")}</span>}>
                                    <span className="pf-initial-date">{moment(product?.initialStart)?.format("DD/MM/YY")}</span>
                                </Tooltip>
                            )}
                        </div>
                        <div className="pf-cell pf-date-cell" data-label={fm('offer.product.col.end', 'End')}>
                            <input
                                type={isSherbim ? "date" : "text"}
                                value={(product?.end && (isSherbim ? product?.end : formatDate(product?.end))) || ''}
                                onChange={isSherbim ? (e) => handleChange('end', e.target.value) : undefined}
                                disabled={!isSherbim}
                            />
                            {product?.initialEnd && (
                                <Tooltip placement="top" overlay={<span>{fm('offer.product.initialDate', 'Initial date')}: {moment(product?.initialEnd)?.format("DD-MM-YYYY")}</span>}>
                                    <span className="pf-initial-date">{moment(product?.initialEnd)?.format("DD/MM/YY")}</span>
                                </Tooltip>
                            )}
                        </div>
                    </div>
                    <div className="pf-note">
                        <span className="pf-note-label"><FormattedMessage id="offer.product.note" defaultMessage="Note:" /></span>
                        <textarea
                            value={product?.note || ''}
                            onChange={(e) => handleChange('note', e.target.value)}
                            rows={1}
                        />
                    </div>
                </div>
            </div>}

            {/* ── Sub-products section ── */}
            {!!product?.id && (
                <SubProductSection
                    productId={product.id}
                    productIndex={props.indexWhereThisProductIsPlacedInTheArray}
                    parentDiscount={product.discount || 0}
                    articles={props.articles}
                    permissions={props.permissions}
                    readOnly={!!product?.canceled}
                    onSubProductsChange={(subs: OfferSubProduct[]) => {
                        const total = subs.reduce((sum, sp) => sum + (sp.totalPrice || 0), 0);
                        setSubProductsTotal(total);
                        // Discounted sub-products total — falls back to gross per line when
                        // that sub-product carries no offer-level discount yet.
                        const discTotal = subs.reduce((sum, sp) => sum + (sp.discountPrice != null ? Number(sp.discountPrice) : (sp.totalPrice || 0)), 0);
                        setSubProductsDiscountedTotal(discTotal);
                        if (props.setProducts) {
                            props.setProducts((prev: OfferProduct[]) =>
                                prev.map((p, i) =>
                                    i === props.indexWhereThisProductIsPlacedInTheArray
                                        ? { ...p, subProducts: subs }
                                        : p
                                )
                            );
                        }
                    }}
                />
            )}

            {/* ── KuBIT per-offer bill of materials — manufactured lines, KuBIT tenants ── */}
            {!!product?.id && props.companyProfile?.kubitEnabled && kubitItemTypeId === 4 && (
                <OfferBomSection productId={product.id} readOnly={!!product?.canceled} />
            )}

            {/* Combined total when sub-products exist — reflects the offer discount */}
            {subProductsTotal > 0 && (
                <div className="product-combined-total">
                    <span className="product-combined-total-label">
                        <FormattedMessage id="offer.product.combinedTotal" defaultMessage="Combined total"/>:
                    </span>
                    <span className="product-combined-total-value">
                        {props?.discount && !product?.canceled ? (
                            <DiscountedPrice
                                original={(calculatedTotalProductPrice || 0) + subProductsTotal}
                                discounted={(+props.discount || 0) + subProductsDiscountedTotal}
                            />
                        ) : (
                            `${formatNumberPrice((calculatedTotalProductPrice || 0) + subProductsTotal, 2)} €`
                        )}
                    </span>
                </div>
            )}

            <ModalComponent
                isModalHeader
                isOpen={isDeleteModalOpen}
                close={setDeleteModal}
            >
                <DeleteModalComponent
                    history={props.history}
                    close={() => setDeleteModal(false)}
                    deleteFunction={() => deleteProduct()}/>
            </ModalComponent>
            <ModalComponent
                isModalHeader
                isOpen={isCancelModalOpen}
                close={setCancelModal}
            >
                <DeleteModalComponent
                    history={props.history}
                    close={() => setCancelModal(false)}
                    deleteFunction={() => cancelProduct()}/>
            </ModalComponent>
        </div>
    );
};

function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        offers: state.offers,
        admin: state.admin,
        client: state.client
    };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        offerActions: bindActionCreators(offerActions as any, dispatch),
        adminActions: bindActionCreators(adminActions as any, dispatch),
    };
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(Product as any)));
